//Componentes generales
import React, { useReducer } from "react";
import distribucionesReducer from "./distribucionesReducer";
import distribucionesContext from "./distribucionesContext";

//Rutas de api
import { getDistribuciones, uploadDistribucion } from "../../api/distribucion"

//Acciones
import {
    ACTUALIZAR_DISTRIBUCIONES,
    ACTUALIZAR_DISTRIBUCIONES_DB,
    CARGANDO_DIST,
    ERROR_DIST,
    LIMPIAR_ERROR
} from "./distribucionesActions";

/*
    State encargado de la gestión de distribuciones.
*/
const DistribucionesState = props => {

    //Valores iniciales
    const initialState = {
        distribuciones: [],
        cargando: false,
        error: ""
    };

    const [state, dispatch] = useReducer(distribucionesReducer, initialState);

    /*
        Función recuperar las distribuciones.
    */
    const actualizarDistribuciones = async () => {

        try{
            const resp = await getDistribuciones();
            dispatch({
                type: ACTUALIZAR_DISTRIBUCIONES,
                payload: resp.data.data
            })
            return resp.data.data;

        }catch(error){
            console.log(error);
        }
    }

    /*
        Función encargada de sobreescribir la tabla de distribuciones con la propia de Softland.
            Donde userID es el ID del usuario en sesión.
                  userName es el nombre del usuario en sesión.
    */
    const actualizarDistribucionesDB = async (userID, userName) => {

        try{
            await uploadDistribucion(userID, userName);
            const resp = await getDistribuciones();
            dispatch({
                type: ACTUALIZAR_DISTRIBUCIONES_DB,
                payload: resp.data.data
            });
        return {status: true, msg: "Se actualizo con exito la base de datos."};

        }catch(error){
            console.log(error);
            dispatch({
                type: ERROR_DIST,
                payload: error.response.data.errMsg
            });

            return {status: false, msg: error.response.data.errMsg};
        }
    }

    const cargando =  () => {
        dispatch({
            type: CARGANDO_DIST
        })
    }

    const limpiarError = () => {
        dispatch({
            type: LIMPIAR_ERROR
        })
    }

    return(
        <distribucionesContext.Provider
            value={{
                distribuciones: state.distribuciones,
                isCargando: state.cargando,
                error: state.error,
                actualizarDistribuciones,
                actualizarDistribucionesDB,
                cargando,
                limpiarError
            }}
        >

            {props.children}

        </distribucionesContext.Provider>
    )

}

export default DistribucionesState;
